var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"close-icon",attrs:{"viewBox":"0 0 1024 1024","icon":"","color":_vm.color},on:{"click":_vm.handleClick}},[_c('v-icon',[_vm._v(" mdi-close ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }